import CurrencySwitcher from '../../UiKit/Blocks/CurrencySwitcher/CurrencySwitcher';
import Slider from './PriceSlider';

const KEY_FROM_FULL = 'min_full_price';
const KEY_TO_FULL = 'max_full_price';
const KEY_FROM_SQM = 'min_price_sqm';
const KEY_TO_SQM = 'max_price_sqm';

class FunnelPrice {
  constructor(options) {
    this.root = document.querySelector('[data-funnel="price"]');
    if (!this.root) return;
    this.prices = this.root.querySelectorAll('[data-slider]');
    this.switches = this.root.querySelectorAll('[data-switch]');
    this.onSwitch = options.onSwitch;
    this.onAssign = options.onAssign;
    this.sliders = [];
    this.attachSliders();
    this.attachEvents();

    new CurrencySwitcher(true, {
      root: this.root,
      onMount: (currency) => {
        this.sliders.forEach((slider) => {
          slider.setCurrency(currency, true);
        });
      },
      onChange: (currency) => {
        this.sliders.forEach((slider) => {
          slider.setCurrency(currency);
        });
      },
    });
  }

  attachSliders() {
    [].forEach.call(this.prices, (price) => {
      const sliderNode = price.querySelector('[data-slider-initial]');
      const minValueNode = price.querySelector('[data-value-min]');
      const maxValueNode = price.querySelector('[data-value-max]');
      const chartNode = price.querySelector('[data-slider-chart]');
      const isFullPrice = price.getAttribute('data-slider') === 'full_price';
      const slider = new Slider(sliderNode, {
        onUpdate: ({ min, max }) => {
          minValueNode.textContent = `${min}`;
          maxValueNode.textContent = `${max}`;
        },
        onChange: (prices, currency) => {
          const keys =
            isFullPrice
              ? [KEY_FROM_FULL, KEY_TO_FULL]
              : [KEY_FROM_SQM, KEY_TO_SQM];
          let [min, max] = prices;
          if (currency === 'usd') {
            [min, max] = prices.map((p) => {
              return Math.round(p * window.currencyRateUSD);
            });
          }

          if (Number(prices[0]) === (currency === 'usd' ? slider.minUsd : slider.minUah)) {
            this.onAssign(keys[0], false);
          } else {
            this.onAssign(keys[0], Number(min));
          }

          if (Number(prices[1]) === (currency === 'usd' ? slider.maxUsd : slider.maxUah)) {
            this.onAssign(keys[1], false);
          } else {
            this.onAssign(keys[1], Number(max));
          }
        },
        isFullPrice,
        chartNode,
      });
      this.sliders.push(slider);
    });
  }

  attachEvents() {
    [].forEach.call(this.switches, (sw) => {
      const key = sw.getAttribute('data-switch');
      const link = sw.parentElement.querySelector('a');

      sw.addEventListener('change', () => {
        this.onSwitch(key);
      });
      link?.addEventListener('click', (e) => {
        e.preventDefault();
        this.onSwitch(key);
        sw.checked = !sw.checked;
      });
    });
  }

  count() {
    let count = 0;
    if (!this.root) return count;
    [].forEach.call(this.switches, (sw) => {
      if (sw.checked) count += 1;
    });
    [].forEach.call(this.sliders, (slider) => {
      const values = slider.node.noUiSlider.get(true);
      if (values[0] > slider.min || values[1] < slider.max) {
        count += 1;
      }
    });
    return count;
  }

  reset() {
    if (!this.root) return;
    this.resetKeys = {
      [KEY_FROM_FULL]: false,
      [KEY_TO_FULL]: false,
      [KEY_FROM_SQM]: false,
      [KEY_TO_SQM]: false,
    };

    [].forEach.call(this.switches, (sw) => {
      const key = sw.getAttribute('data-switch');
      sw.checked = false;
      this.resetKeys[key] = false;
    });

    [].forEach.call(this.sliders, (slider) => {
      slider.reset();
    });
  }
}

export default FunnelPrice;
